<template>
  <div v-if="appointment && appointment.car">
    <tab-title
      :car-id="appointment.car.id"
      text="オーナー情報" />
    <cp-appointment-summary
      :appointment="appointment"
    />
    <v-form
      v-if="appointment"
      ref="form">
      <v-text-field
        :value="appointment.customer.lastName"
        readonly
        disabled
        class="mb-3"
        placeholder="氏名"
        label="氏名"
      />
      <v-layout
        :column="isMobile"
        class="mb-3">
        <v-flex
          :class="!isMobile && 'pr-2'"
        >
          <v-select
            v-model="appointment.car.deliveryTime"
            :items="getMonths(appointment.car.deliveryTime)"
            :rules="[$rules.isRequired]"
            label="車両引き渡し時期 *"
            data-label-scroll="deliveryTime"
            @change="(value) => updateCar({ field: 'deliveryTime', value })"
          />
        </v-flex>
        <v-flex
          :class="!isMobile && 'pl-2'"
        >
          <v-select
            v-model="appointment.car.deliveryTime"
            :items="getDays(appointment.car.deliveryTime)"
            :rules="[$rules.isRequired]"
            label="車両引き渡し旬日 *"
            data-label-scroll="deliveryTime"
            @change="(value) => updateCar({ field: 'deliveryTime', value })"
          />
        </v-flex>
      </v-layout>
      <v-layout
        :column="isMobile"
        class="mb-3">
        <v-flex
          :class="!isMobile && 'pr-2'"
        >
          <v-select
            v-model="appointment.car.documentHandoverTime"
            :items="getMonths(appointment.car.documentHandoverTime)"
            :rules="[$rules.isRequired]"
            label="書類引き渡し時期 *"
            data-label-scroll="documentHandoverTime"
            @change="(value) => updateCar({ field: 'documentHandoverTime', value })"
          />
        </v-flex>
        <v-flex
          class="pl-2"
        >
          <v-select
            v-model="appointment.car.documentHandoverTime"
            :items="getDays(appointment.car.documentHandoverTime)"
            :rules="[$rules.isRequired]"
            label="書類引き渡し旬日 *"
            data-label-scroll="documentHandoverTime"
            @change="(value) => updateCar({ field: 'documentHandoverTime', value })"
          />
        </v-flex>
      </v-layout>
      <photo-group
        :items="photosList"
        :photos="photos"
        tab="owner"
      />
      <v-divider class="my-5" />
      <v-btn
        outline
        color="info"
        block
        large
        to="basic#top">次へ</v-btn>
    </v-form>
  </div>
</template>

<script>
import { APPOINTMENT_AND_OWNER_SUMMARY, GET_PHOTOS } from '../../queries';
import PhotoGroup from '../../components/fields/PhotoGroup';

const photosList = [
  {
    name: 'driver_license_front',
    label: '運転免許証(表)',
    required: false,
  },
  {
    name: 'driver_license_back',
    label: '運転免許証(裏)',
    required: false,
  },
];

export default {
  components: {
    PhotoGroup,
  },
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    photos: {
      query: GET_PHOTOS,
      variables() {
        return {
          id: parseInt(this.appointmentId, 10),
        };
      },
    },
    appointment: {
      query: APPOINTMENT_AND_OWNER_SUMMARY,
      fetchPolicy: 'network-only',
      variables() {
        return {
          id: parseInt(this.appointmentId, 10),
        };
      },
    },
  },
  data() {
    return {
      photosList,
      tab: 'owner',
    };
  },
  methods: {
    getMonths(value) {
      const now = new Date();

      const date = value
        || `${now.getUTCFullYear()}-${(`00${now.getUTCMonth() + 1}`).slice(-2)}-${(`00${now.getUTCDate()}`).slice(-2)}`;

      return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map(m => ({
        text: `${m}月`.replace(/^0/, ''),
        value: `${date.slice(0, 4)}-${m}-${date.slice(8, 10)}`,
      }));
    },
    getDays(value) {
      const now = new Date();

      const date = value
        ? value.slice(0, 7)
        : `${now.getUTCFullYear()}-${(`00${now.getUTCMonth() + 1}`).slice(-2)}`;

      return [{
        value: `${date}-01`,
        text: '上旬',
      }, {
        value: `${date}-10`,
        text: '中旬',
      }, {
        value: `${date}-20`,
        text: '下旬',
      }];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/OwnerTab.vue